"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.width = exports.observer = void 0;
var width = exports.width = {
  window: function (_window) {
    function window() {
      return _window.apply(this, arguments);
    }
    window.toString = function () {
      return _window.toString();
    };
    return window;
  }(function () {
    return window.innerWidth;
  }),
  container: function container(_ref) {
    var _container$getBoundin;
    var _container = _ref.container;
    return _container === null || _container === void 0 ? void 0 : (_container$getBoundin = _container.getBoundingClientRect()) === null || _container$getBoundin === void 0 ? void 0 : _container$getBoundin.width;
  }
};
var observer = exports.observer = {
  window: function window(_ref2) {
    var updateSize = _ref2.updateSize;
    return windowListener({
      updateSize: updateSize
    });
  },
  container: function container(_ref3) {
    var updateSize = _ref3.updateSize,
      _container2 = _ref3.container;
    return containerObserver({
      updateSize: updateSize,
      container: _container2
    });
  }
};
var containerObserver = function containerObserver(_ref4) {
  var updateSize = _ref4.updateSize,
    container = _ref4.container;
  var resizeObserver = new ResizeObserver(updateSize);
  return {
    observe: function observe() {
      resizeObserver.observe(container);
    },
    unobserve: function unobserve() {
      resizeObserver.unobserve(container);
    }
  };
};
var windowListener = function windowListener(_ref5) {
  var updateSize = _ref5.updateSize;
  return {
    observe: function observe() {
      window.addEventListener('resize', updateSize);
    },
    unobserve: function unobserve() {
      window.removeEventListener('resize', updateSize);
    }
  };
};